export default __webpack_public_path__ + "claude.png";